<script>
    import Spinner from 'vue-simple-spinner';
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            source: String
        },
        components: {Spinner},
        data() {
            return {
                form: new Form({
                    age: 1
                })
            }
        },
        watch: {
            'form.age': {
                handler(val) {
                    this.onSubmit()
                }
            }
        },
        methods: {
            decrement() {
                if (this.form.age > 1) {
                    this.$set(this.form, 'age', this.form.age--)
                }
            },
            increment() {
                this.$set(this.form, 'age', this.form.age + 1)
            },
            onClose() {
                this.form.reset()
            },
            onSubmit() {
                this.form
                    .get(this.source, {}, true)
                    .then(({courses}) => {
                        this.$emit('update', {
                            courses,
                            params: this.form.data()
                        })
                        $("#giftAgeModal").modal('hide')
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftSearchAgeForm.vue